module.exports = __webpack_public_path__ + "img/appliance_professional.ed24d86a.jpg";